

window.onload = function() {
  if(window.location.href.indexOf("darkove-zbozi") > -1) {
       document.querySelector('.collection-sidebar__group--1556196075170').style.display = 'none';
       document.querySelector('.collection-sidebar__group--1556196323570').style.display = 'none';
       document.querySelector('.collection-sidebar__group--1556196399989').style.display = 'none';
       document.querySelector('.collection-sidebar__group--1556196453800').style.display = 'none';
       document.querySelector('.collection-sidebar__group--1556196399989').style.display = 'none';
       document.querySelector('.collection-sidebar__group--1556647500388').style.display = 'none';
    
    }
   else if(window.location.href.indexOf("kolekce") > -1) {
       document.querySelector('.collection-sidebar__group--1556272490094').style.display = 'none';
    }
};
